import { takeLatest, put, call } from 'redux-saga/effects';

import { TAction } from 'shared/types';
import PatientConversationService from 'shared/services/PatientConversationService';
import {
  getChannels,
  getChannelsFail,
  setChannels,
  setUnreadCount,
  getUnreadCount
} from './patientConversation.redux';
import { IPatientConversation } from 'shared/interfaces/conversation.interface';

function* getPatientConversationChannelsSaga({
  payload
}: TAction<{ patientId: string }>) {
  try {
    const result: IPatientConversation = yield call(
      PatientConversationService.getChannels,
      payload
    );

    yield put(setChannels(result));
  } catch (error) {
    yield put(getChannelsFail());
    console.log('getPatientConversationChannelsSaga error', error);
  }
}
function* getUnreadCountSaga() {
  try {
    const result: { unread_count: number } = yield call(
      PatientConversationService.getUnreadCount
    );

    yield put(setUnreadCount(result.unread_count));
  } catch (error) {
    yield put(getChannelsFail());
    console.log('getPatientConversationChannelsSaga error', error);
  }
}

function* PatientConversation() {
  yield takeLatest(getChannels.type, getPatientConversationChannelsSaga);
  yield takeLatest(getUnreadCount.type, getUnreadCountSaga);
}

export default PatientConversation;
